import type { NodeParameters } from '../../../types/node-properties';

/**
 * Default parameter values for Data Table node
 * These values are used when a new node is created
 */
export const defaults: NodeParameters = {
  // Table selection
  tableId: '',

  // Main operation
  operation: 'getAll',

  // Create Table operation
  newTableName: '',
  newTableDescription: '',
  newTableSchema: `{
  "columns": [
    { "name": "customerId", "type": "string", "required": true },
    { "name": "amount", "type": "number", "required": true },
    { "name": "status", "type": "string" },
    { "name": "createdDate", "type": "datetime" }
  ],
  "primaryKey": "customerId"
}`,
  failIfExists: false,

  // Create if not exists (for write operations)
  createIfNotExists: false,
  newTableNameForCreate: '',

  // Get All options
  filter: '',
  orderBy: '',
  limit: 100,

  // Get by ID / Update / Delete
  rowId: '',
  rowIdForUpdate: '',

  // Query
  query: "SELECT * FROM @table WHERE status = 'active'",

  // Insert / Update / Upsert
  data: '{\n  "name": "{{ $json.name }}",\n  "email": "{{ $json.email }}"\n}',

  // Upsert
  upsertKey: 'id',

  // Append / Replace All
  rows: '{{ $json }}',
  confirmReplaceAll: false,

  // Bulk operations
  bulkCondition: '',
  bulkUpdateData: '{\n  "status": "archived"\n}',
};

export default defaults;
